import styled from 'styled-components';
import { device } from './responsives';

export const SectionTitleStyle = styled.h2`
  font-size: 32px;
  line-height: 32px;
  font-family: Avenir;
  font-weight: 900;
  margin-top: 24px;
  margin-bottom: 0px;
  color: #4a4a4a;

  @media ${device.maxlaptop}{
    line-height: 24px;
    font-size: 24px;
  }
`
